import { Results } from '@mediapipe/selfie_segmentation';
import { SelfieSegmentation } from '@mediapipe/selfie_segmentation/selfie_segmentation';	

let callback: Function;
let currFrame: HTMLVideoElement | HTMLCanvasElement;

export function setupFaceSegmentation(cb: Function){
	selfieSegmentation.setOptions({
		// 0 is general model, 1 is landscape model
		modelSelection: 0, 
	});
	selfieSegmentation.onResults(onResults);
	callback = cb;
	let canvas = document.createElement('canvas');
	selfieSegmentation.send({ image: canvas });
}


export function faceSegment(frame: HTMLVideoElement | HTMLCanvasElement, cb: Function){
	callback = cb;
	currFrame = frame;
	selfieSegmentation.send({ image: frame });
}

const selfieSegmentation = new SelfieSegmentation({
	locateFile: (file) => {
		console.log("looking for file", file)
		return `/js/selfie_segmentation/${file}`;
	}
});
function onResults(results: Results) {
	if (!results) {
		return;
	}
	// draw segmentation mask
	if (results && results.segmentationMask) {
		if(callback) callback(results.segmentationMask, results.image);
	} else{
		if(callback) callback(null);
	}
}